<template>
  <split-pane :min-percent="20" :default-percent="20" split="vertical">
    <!--左侧-->
    <template slot="paneL">
      <a-card title="组织架构">
        <a-tree :tree-data="treeData" :expandedKeys.sync="expandedKeys" @select="selectTreeNode">
          <template #title="{ key: treeKey, title, code }">
            <a-dropdown :trigger="['contextmenu']">
              <span>{{ title }}</span>
              <template #overlay>
                <a-menu @click="({ key: menuKey }) => onContextMenuClick(treeKey, menuKey, code)">
                  <a-menu-item key="1">编辑</a-menu-item>
                  <a-menu-item key="2" v-if="code !== 'school' && userInfo().username === 'admin'">
                    删除
                  </a-menu-item>
                  <a-menu-item key="3">新增下级</a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </template>
        </a-tree>
      </a-card>
    </template>

    <!--右侧数据列表-->
    <template slot="paneR">
      <a-card :title="selectTreeData.title ? selectTreeData.title : '学生家长管理'">
        <a slot="extra" href="#">more</a>

        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="学生姓名">
                  <a-input
                    v-model="queryParam.name"
                    style="width: 100%"
                    @pressEnter="searchQuery"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="选择标签">
                  <a-select
                    show-search
                    placeholder="请选择标签"
                    option-filter-prop="children"
                    :filter-option="filterOption"
                    @change="handleTagChange"
                    allowClear
                  >
                    <a-select-option v-for="item in keyword" :key="item.value" :value="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button
                    type="primary"
                    @click="searchReset"
                    icon="reload"
                    style="margin-left: 8px"
                  >
                    重置
                  </a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 查询区域-END -->

        <!-- 操作按钮区域 -->
        <div class="table-operator">
          <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>

          <a-button @click="updateFace" type="primary" icon="picture">更新照片</a-button>

          <a-button type="primary" icon="import" style="margin-right: 10px" @click="importTag">
            导入标签
          </a-button>

          <a-button
            type="primary"
            icon="import"
            style="margin-right: 10px"
            @click="importStudentInfo"
          >
            导入学生信息
          </a-button>
        </div>

        <!-- table区域-begin -->
        <div>
          <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
            <i class="anticon anticon-info-circle ant-alert-icon"></i>
            已选择
            <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>
            项
            <a style="margin-left: 24px" @click="onClearSelected">清空</a>
          </div>

          <a-table
            ref="table"
            size="middle"
            :scroll="{ x: true }"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            class="j-table-force-nowrap"
            @change="handleTableChange"
          >
            <template slot="htmlSlot" slot-scope="text">
              <div v-html="text"></div>
            </template>

            <template slot="pic" slot-scope="text">
              <span v-if="!text" style="font-size: 12px; font-style: italic">无图片</span>
              <img
                v-else
                :src="getImgView(text)"
                @click="showImgDialog(getImgView(text))"
                height="80px"
                alt
                style="max-width: 80px; font-size: 12px; font-style: italic"
              />
            </template>
            <template slot="fileSlot" slot-scope="text">
              <span v-if="!text" style="font-size: 12px; font-style: italic">无文件</span>
              <a-button
                v-else
                :ghost="true"
                type="primary"
                icon="download"
                size="small"
                @click="downloadFile(text)"
              >
                下载
              </a-button>
            </template>

            <span slot="action" slot-scope="text, record">
              <a @click="handleEdit(record)">编辑</a>

              <a-divider type="vertical" />
              <a-dropdown>
                <a class="ant-dropdown-link">
                  更多
                  <a-icon type="down" />
                </a>
                <a-menu slot="overlay">
                  <!--                <a-menu-item>-->
                  <!--                  <a @click="handleDetail(record)">详情</a>-->
                  <!--                </a-menu-item>-->
                  <a-menu-item>
                    <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                      <a>删除</a>
                    </a-popconfirm>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>
          </a-table>
        </div>
        <a-modal
          hoverable
          title="查看照片"
          :visible="imgboxModal"
          centered
          @cancel="() => ((imgModelSrc = ''), (imgboxModal = false))"
          width="50%"
          :footer="null"
        >
          <img :src="imgModelSrc" alt style="width: 100%" />
        </a-modal>

        <student-info-modal ref="modalForm" @ok="modalFormOk"></student-info-modal>
        <update-student-face-modal
          ref="updateStudentFaceModal"
          @ok="modalFormOk"
        ></update-student-face-modal>
        <TemplateUploadFile ref="templateUploadFile" />

        <ImportStudentInfo ref="importStudentInfo" />

        <studentGradeModal ref="studentGradeModal" />
        <schoolClassModal ref="schoolClassModal" />
        <tenantModal ref="tenantModal" />
      </a-card>
    </template>
  </split-pane>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import StudentInfoModal from '../studentInfo/modules/StudentInfoModal'
import UpdateStudentFaceModal from '../studentInfo/modules/UpdateStudentFaceModal'
import { filterDictText } from '@/components/dict/JDictSelectUtil'
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
import { simpleDebounce } from '@/utils/util'
import TemplateUploadFile from '@/components/TemplateUploadFile'
import ImportStudentInfo from '@/components/ImportStudentInfo'
import { getAction } from '@/api/manage'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css' // 引入它的 css
import { RecycleScroller } from 'vue-virtual-scroller'
import { mapGetters } from 'vuex'
import splitPane from 'vue-splitpane'
import StudentGradeModal from '../studentGrade/modules/StudentGradeModal'
import SchoolClassModal from '../schoolClass/modules/SchoolClassModal'
import TenantModal from '../../system/modules/TenantModal'

export default {
  name: 'AddressBook',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    splitPane,
    StudentInfoModal,
    filterDictText,
    UpdateStudentFaceModal,
    JSearchSelectTag,
    TemplateUploadFile,
    RecycleScroller,
    ImportStudentInfo,
    StudentGradeModal,
    SchoolClassModal,
    TenantModal,
  },
  data() {
    return {
      treeData: [],
      expandedKeys: [],
      selectTreeData: {},
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '学生姓名',
          align: 'center',
          dataIndex: 'name',
        },
        {
          title: '学生照片',
          align: 'center',
          dataIndex: 'pic',
          scopedSlots: { customRender: 'pic' },
        },
        {
          title: '所属班级',
          align: 'center',
          dataIndex: 'schoolClass.name',
        },
        {
          title: '关爱等级',
          align: 'center',
          dataIndex: 'careList_dictText',
          sorter: true,
        },
        {
          title: '标签',
          align: 'center',
          dataIndex: 'tags',
        },
        // {
        //   title: '心情灯设备号',
        //   align: 'center',
        //   dataIndex: 'moodLampId',
        // },
        // {
        //   title: '心情灯状态',
        //   align: 'center',
        //   dataIndex: 'moodLampStatus_dictText',
        // },
        // {
        //   title: '是否注册',
        //   align: 'center',
        //   dataIndex: 'regId',
        //   customRender: function (t, r, index) {
        //     return t !== '0'?'是':'否'
        //   },
        // },

        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/aigoes/studentInfo/list?deleteFlag=0',
        delete: '/aigoes/studentInfo/delete',
        deleteBatch: '/aigoes/studentInfo/deleteBatch',
        exportXlsUrl: '/aigoes/studentInfo/exportXls',
        importExcelUrl: '/aigoes/studentInfo/importExcel',
        treeData: '/aigoes/studentInfo/treeData',
      },
      imgboxModal: false,
      imgModelSrc: '',
      dictOptions: {},
      tagOptions: [],
      searchContextList: [],
      keyword: [],
    }
  },
  created() {
    // 获取组织架构
    this.getTreeData()
    // 标签
    this.getSearchKeyword()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    ...mapGetters(['userInfo']),
    /**
     * 获取组织架构
     */
    getTreeData() {
      getAction(this.url.treeData).then((res) => {
        this.treeData = res.result
        this.expandedKeys.push(this.treeData[0].key)
      })
    },
    /**
     * 左键点击树节点
     */
    selectTreeNode(selectedKey, { selected, node }) {
      this.selectTreeData = {
        key: node.dataRef.key,
        code: node.dataRef.code,
        title: node.dataRef.title,
      }
      console.log(node)
      if (node.dataRef.code === 'school') {
        this.queryParam.classId = ''
        this.queryParam.gradeId = ''
      } else if (node.dataRef.code === 'grade') {
        this.queryParam.classId = ''
        this.queryParam.gradeId = node.dataRef.key
      } else if (node.dataRef.code === 'class') {
        this.queryParam.classId = node.dataRef.key
        this.queryParam.gradeId = ''
      }
      this.loadData()
    },
    onContextMenuClick(treeKey, menuKey, code) {
      if (code === 'school') {
        this.$refs['tenantModal'].edit({ id: treeKey })
      } else if (code === 'grade') {
        this.$refs['studentGradeModal'].edit({})
      } else if (code === 'class') {
        this.$refs['schoolClassModal'].edit({})
      }
    },
    initDictConfig() {},
    showImgDialog(src) {
      console.log(src)
      this.imgboxModal = true
      this.imgModelSrc = src
    },
    updateFace() {
      this.$refs['updateStudentFaceModal'].show()
    },
    searchTag: simpleDebounce(function (value) {
      this.keyword = this.searchContextList.filter((item) => item.label.includes(value))
      console.log('过滤后的keys：', this.keyword)
    }, 300),
    handleTagChange(value) {
      console.log('选择的标签', value)
      this.queryParam.tagId = value
    },
    importTag() {
      this.$refs.templateUploadFile.showModal()
    },
    importStudentInfo() {
      this.$refs.importStudentInfo.showModal()
    },
    handleSearch: simpleDebounce(function (value) {
      // console.log('过滤条件--', value)
      this.queryParam.con = value || ''
      if (!this.searchContextList.length) {
        this.getSearchKeyword()
      } else {
        this.keyword = value
          ? this.searchContextList.filter((item) => item.name.includes(value))
          : this.searchContextList
      }
    }, 300),
    handleSelect(value) {
      console.log('选择的标签', value)
      this.queryParam.tagId = value
    },
    getSearchKeyword() {
      getAction('/statistic/getKeyword', {
        dataType: '3',
      }).then((res) => {
        if (res.success) {
          this.searchContextList = res.result.map((item) => ({
            label: item.name,
            value: item.period_id,
          }))
          this.keyword = this.searchContextList
        }
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
.virtual-list {
  // y轴滚动
  overflow-y: auto;
  // 隐藏x轴滚动条
  overflow-x: hidden;
}
.list-item {
  display: flex;
  align-items: center;
  font-size: 14px;
  height: 32px;
  padding-left: 10px;
  cursor: pointer;
}
</style>
